import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { updateUserAttributes as updateCognitoUserAttributes } from 'aws-amplify/auth';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import endUserMessages from 'utils/endUserMessages';
import fetchUserAttributesCached from 'utils/fetchUserAttributesCached';
import loadUser from './loadUser';
var updateUserAttributes = function updateUserAttributes(user, attributes) {
  var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return updateCognitoUserAttributes({
              userAttributes: attributes
            });
          case 3:
            fetchUserAttributesCached.cache.clear();
            _context.next = 6;
            return dispatch(loadUser());
          case 6:
            pushNotificationMessage('success', endUserMessages.ACCOUNT_DETAILS_UPDATED, 3);
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            pushNotificationMessage('error', 'Something went wrong while updating your account details', 3);
            onError();
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateUserAttributes;